import { cloneDeep, clone, sortBy } from 'lodash-es';
import { BookingStatusNames } from 'app/bookingStatusTypes';
import LocationService from "external-services/location-service";
import { StatusService } from "external-services/status-service";
import NetworkConnectionService from 'external-services/network-connection-service/index';
import TelemetryService from "app/services/telemetry/telemetry.service";
import NotesService from "external-services/notes-service/index";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import AdminService from "external-services/diary-admin-service/admin.service";
import StatusConfigService from "external-services/status-config-service/index";
import BackChannelService from 'app/services/backChannel/backChannel.service';
import BookingsAffectedService from "app/services/bookingsAffected/bookingsAffected.service";
import PaymentService from "external-services/diary-payment-service";
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import SectionGroupsService from "external-services/section-groups-service/sectionGroups.service";
import LayoutsService from 'external-services/layouts-service/layouts.service';
import BookingsUtilsService from 'app/services/bookingsUtils/bookingsUtils.service';
import SpamProtectionService from "external-services/spam-protection-service/SpamProtection.service";
import ScheduleLookupService from 'external-services/schedule-lookup-service/scheduleLookup.service';
import PouchActions, { PouchDocType } from "app/actions/pouch.actions";
import PouchSyncService, { quickEditProps } from "external-services/pouch-sync-service/index";
import { BookingAvailabilityService } from "app/services/LegacyBookingAvailabilityService";
import BookingsConflicts from "app/services/bookingsConflicts";
import BookingLookupService from "external-services/booking-lookup-service";
import BookingUpdateService from "external-services/booking-update-service/index";
import TableUtilsService from "external-services/table-utils-service";
import TableJoinService from "app/services/tableJoin/tableJoin.service";
import EventsService from "app/services/events/events.service";
import { BookingMethods } from "shared-types/SharedTypes";
import DateUtilsService from 'external-services/date-utils-service';
import BookingService from "app/services/booking/booking.service";
import ServicesLookupService from "shared-services/services-lookup-service";
import { first } from "rxjs/operators";
import BookingListFilterService from "external-services/booking-list-filter-service/index";
import ObjectCopyService from 'external-services/object-copy-service/index';
import ViewActionsService from 'app/actions/view.actions';
import store from 'appRoot/Store';
import { scheduleActions } from 'app/reducers/schedule/slice';
import { settingActions } from 'app/reducers/settings/slice';
import { FloorPlanState } from 'app/reducers/settings/types';
import LocalStorageService from 'external-services/local-storage-service/localStorage.service';
import { NgLocalStorageKey, BookingType, loadStatus, IDiaryService } from 'shared-types/index';
import { blockoutTypeEnums } from 'app/common/BlockoutsByService/types';
import PeriodicUpdateService from 'floorplan-v2/app/services/periodicUpdate';
import { floorplanV2SectionsActions } from 'floorplan-v2/app/reducers/sections/slice';
import { tableDragActions } from "floorplan-v2/app/reducers/tableDrag/slice";
import { showDragBookingConfirmDialog } from "app/bookings/timeList/dragBookingConfirm/showDragBookingConfirmDialog";
import { TableDragService } from 'app/services/tableDrag/TableDrag.service';
import FloorplanBookingDragService from "floorplan-v2/app/services/FloorplanBookingDrag";
import FloorplanBookingFilterService from "floorplan-v2/app/services/floorplanBookingFilter";
import TablesLookupService from 'external-services/tables-lookup-service/tablesLookup.service';
import { bookingActions, updateBookingIdsForCouchResponse } from 'app/reducers/booking/slice';
import { rootDisplayActions } from 'app/reducers/display/slice';
import { serviceActions } from 'app/reducers/service/slice';
import { filterBookingActions } from 'booking-card-list/reducers/filterBooking/slice';
import { sectionActions } from 'app/reducers/section/slice';
import MainViewVisibilityService from "app/services/mainViewVisibility/index";
import { MainViewType } from "app/services/mainViewVisibility/types";
import LoginActions from 'app/actions/login.actions';
import FloorplanConflictsService from "floorplan-v2/app/services/FloorplanConflictsService";

/**
 * Note: this controller gets used on route 'settings.bookings'
 */

const NS = 'BookingsCtrl';

const isAndroidOrIOS = LocationService.isIOS() || LocationService.isAndroid();
const forceBookingCardList = !!window.config?.forceBookingCardList;

export default function BookingsCtrl(
  $rootScope, $q, $scope, $log, $state, $mdDialog, $window, $document,
  $filter, $timeout,
  bookingsCalulationsService,
  AppEventService, pouchService, AuthService,
  unregister
) {
  "ngInject";

  var vm = this;
  var sectionsLookUp;
  var gettingBookings = false;
  var buildAllViewsTimer = null;
  var bookingQue = 0;
  var checkForAffectedBookingInterval;
  var todaysDate;
  const MIN_EXPANDER_W = 300;
  let changeDatePending = false;

  /**
   * In browser console enter `window.dispatchEvent(new Event('mega-booking-bot'))` to activate.
   */
  const WINDOW_LISTENER_EVENT_MEGA_BOOKING_BOT = "mega-booking-bot";

  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.FAILED_TO_LOAD_BOOKING = 3;
  vm.state = vm.ENTER;

  //-- define public methods
  vm.newBooking = newBooking;
  vm.walkin = walkin;
  vm.megaBookingBotOpen = megaBookingBotOpen;
  vm.megaBookingBotClose = megaBookingBotClose;
  vm.selectService = selectService;
  vm.selectView = selectView;
  vm.changeSection = changeSection;
  vm.closeBookingEdit = closeBookingEdit;
  vm.showConflicts = (...args) => {
    showConflicts(...args, null)
  };
  vm.unallocateAllBookings = unallocateAllBookings;
  vm.finishAllBookings = finishAllBookings;
  vm.reverseFinishAllBookings = reverseFinishAllBookings;
  vm.openGlobalSearch = openGlobalSearch;
  vm.getBookings = getBookings;
  vm.getSchedule = getSchedule;
  vm.openNotes = openNotes;
  vm.addPeople = addPeople;
  vm.minusPeople = minusPeople;
  vm.onServiceFilterChanged = onServiceFilterChanged;
  vm.onSectionFilterChanged = onSectionFilterChanged;
  vm.setExpanderWidth = setExpanderWidth;
  vm.getErrorDetails = getErrorDetails;
  vm.handleDateChangedViaFloorplan = handleDateChangedViaFloorplan;
  var listeners = [];
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));
  // vm.closeBookingCreator = closeBookingCreator;
  const timeZoneId = AdminService.getVenueTimezoneId();

  // lifecycle hook
  vm.$onInit = function () {
    todaysDate = DateUtilsService.getVenueTime(timeZoneId);
    todaysDate.setHours(0);
    todaysDate.setMinutes(0);
    todaysDate.setSeconds(0);
    todaysDate.setMilliseconds(0);

    const isAndroidOrIOSClassName = 'is-android-or-ios';
    document.body.classList.remove(isAndroidOrIOSClassName);
    if (isAndroidOrIOS) {
      document.body.classList.add(isAndroidOrIOSClassName);
    }


    //-- define public properties
    vm.title = 'Bookings';
    vm.previousFilterDate = null; // cache and compare
    vm.filterDate = todaysDate;
    vm.isToday = false;
    vm.isPast = false;
    vm.isBeforeToday = false;
    vm.isOpen = false;
    vm.isPOSActive = AdminService.getVenue().isPOSActive;
    vm.totalsServiceWidth = null;
    vm.venue = AdminService.getVenue();
    vm.currentSection = 0;
    vm.services = [];
    vm.conflicts = false;
    vm.affectedBookings = [];
    vm.skipCheckOpenPoll = false; // just used for unit testing
    vm.expanderWidth = MIN_EXPANDER_W;
    setFilteredBookings(null);
    vm.slottedBookings = null;
    vm.enableMaxOccupancy = false;
    vm.showRevertStatusButton = false;
    vm.showFinishAllButton = false;
    vm.showBlockoutNotification = false;
    vm.activeAddBlockoutsByTable = false;
    vm.errorList = [];
    if (vm.venue.standByList) {
      const { fullStatusOptions } = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
      StatusConfigService.forceUnconfirmedStatus(fullStatusOptions);
    }

    vm.useBookingCardList = false;
    vm.isBookingCardListShown = forceBookingCardList;

    //-- init
    ViewActionsService.registerForReadyCB(() => {
      // some calls like handleBlockoutByTable might be set before the ViewActionsService.setup, unless we use callback
      addListeners();
    });
    checkForConflicts();
    getGeneralSettings().then(() => getViewFromLocalstorage());
    BackChannelService.init();
    if (vm.isPOSActive) {
      AdminService.loadIPOS(AdminService.getVenue().id);
    }
  };

  function setMainViewConfig(currentView, resetAllOpened = false, setBCLShown = true) {
    vm.mainViewConfig = MainViewVisibilityService.getAngularJSHTMLConfig(currentView, resetAllOpened);

    if (setBCLShown && !forceBookingCardList) {
      if (currentView === MainViewType.TimelineV1) {
        vm.serviceViewList && store.dispatch(filterBookingActions.setFilterServiceView(vm.serviceViewList[vm.currentService]))
      }
      setIsBookingCardListShown();
    }

  }

  function getViewFromLocalstorage() {
    try {
      const currentSelectedViewFromLocalstorage = LocalStorageService.get(NgLocalStorageKey.selectedDiaryView);
      const currentVenueId = vm.venue.id;

      const data = JSON.parse(currentSelectedViewFromLocalstorage);

      let viewId = data.view || MainViewType.TimelineV1;

      // Diary View as Default if current venue id is different from localstorage
      if (data.venueId !== currentVenueId) {
        viewId = MainViewType.TimelineV1;
      }

      const isTimeExpired = DateUtilsService.isAfterNow(data.expirationDate)

      // Diary View as Default if time is already expired
      if (isTimeExpired) {
        viewId = MainViewType.TimelineV1;
      }

      // const view = vm.views.find((v) => v.view === viewId);
      const viewConfig = MainViewVisibilityService.getViewByType(viewId);

      selectView(viewConfig);

    } catch (error) {
      const viewConfig = MainViewVisibilityService.getViewByType(MainViewType.TimelineV1);
      selectView(viewConfig);
    }
  }

  function getGeneralSettings() {
    return GeneralSettingsService.get().then(function (settings) {
      vm.useBookingCardList = vm.venue.enableNewFloorPlan && settings.floorPlanSettings?.useBookingCardList;
      vm.enableMaxOccupancy = settings.enableMaxOccupancy;
    });
  }
  function disableBlockoutNotification() {
    vm.showBlockoutNotification = false;
  }
  function setTense() {
    const timeNow = DateUtilsService.getVenueTime(timeZoneId);
    vm.isToday = DateUtilsService.isDateToday(vm.filterDate, timeZoneId);
    vm.isPast = (timeNow.getTime() > vm.filterDate.getTime());
  }
  function addListeners() {
    listeners = [];

    let changeDateTO;

    listeners.push($scope.$watch(() => vm.filterDate, () => {

      if (MainViewVisibilityService.isFloorplanV2Visible()) {
        /**
         * Don't update timeline or runSheet if floorplanV2 is visible.
         * Sets changeDatePending to true so we know we have to call clearBookings and onChangeDate once
         * we have returned to either timeline or runsheet
         */
        getSchedule()
        changeDatePending = true;
        setTense();
        return;
      }

      if (changeDateTO) {
        clearTimeout(changeDateTO);
      }
      clearBookings();
      changeDateTO = setTimeout(onChangeDate, 300); // timeout so you can flick dates quickly without rendering
    }));
    listeners.push($scope.$watch(() => vm.currentService, serviceChange));

    listeners.push($rootScope.$on('select-service', selectService));
    listeners.push($scope.$on('select-service-id', selectServiceById));
    listeners.push($rootScope.$on('edit-booking-people', editBookingPeople));
    listeners.push(ViewActionsService.handleBlockoutFinished((type) => {
      switch (type) {
        case blockoutTypeEnums.byTableAndSection:
          disableBlockoutNotification();
          break;
        case blockoutTypeEnums.byTable:
          vm.activeAddBlockoutsByTable = false;
          break;
      }
    }));
    listeners.push($rootScope.$on('status-edit-inline', editBookingStatus));
    listeners.push(LoginActions.handleTriggerLogout(() => {
      AuthService.logout();
    }));
    listeners.push(ViewActionsService.handleBlockoutByTable((type) => {
      switch (type) {
        case blockoutTypeEnums.byTableAndSection:
          vm.showBlockoutNotification = true;
          break;
        case blockoutTypeEnums.byTable:
          vm.activeAddBlockoutsByTable = true;
          break;
      }
    }));


    listeners.push(ViewActionsService.handleConflictedTableClick((tableId) => handleFloorplanConflictedTableClick(tableId)));
    listeners.push(ViewActionsService.handleBookingViewChanged((viewType) => {
      const viewConfig = MainViewVisibilityService.getViewByType(viewType);
      if (viewConfig) {
        selectView(viewConfig);
      }
    }));
    // listeners.push(ViewActionsService.handleNewBookingOpened(() => {
    //   vm.showBookingCreator = true;
    // }));
    // listeners.push(ViewActionsService.handleNewBookingClosed(() => {
    //   vm.showBookingCreator = false;
    // }));

    listeners.push(
      PouchActions.handlePouchSyncedDoctype(PouchDocType.booking, (evt, ids) => bookingChange(ids))
    );

    listeners.push(
      PouchActions.handlePouchSyncedDoctype(PouchDocType.layout, () => {
        // Force a service refresh to detect the layout changes
        vm.services = [];
        $scope.$apply();
        updateService();
      })
    );
    listeners.push(
      PouchActions.handlePouchSyncedDoctype(PouchDocType.note, () => getNotes())
    );

    $window.addEventListener(WINDOW_LISTENER_EVENT_MEGA_BOOKING_BOT, listenForMegaBookingBotButton);

    listeners.push($scope.$on('$destroy', () => {
      window.clearTimeout(buildAllViewsTimer);
      pouchService.removeOnlineListener();
      unregister(listeners);
      $window.removeEventListener(WINDOW_LISTENER_EVENT_MEGA_BOOKING_BOT, listenForMegaBookingBotButton);
    }));

    // show old dialog if new one NOT enabled in config
    if (!window.config.enableNewDragModal) {
      handleDragBookingEnd(listeners);
    }

  }

  /**
   * @todo: move this function into a TS service inside floorplan
   * TableDragService will need a new submodule
   * getAppropriateTable will need special callback
   */
  function handleDragBookingEnd(listeners) {
    if (vm.venue.enableNewFloorPlan) {
      let draggedBookingRef = null; // IBooking
      const unsubscribe = store.subscribe(() => {

        const state = store.getState();
        const {
          draggedBooking, dragFromTableId, dragCompleteTableId,
          bookingToSwap,
          dragToTableBookingSlot, dragFromTableBookingSlot,
          bookingConfirmDialog
        } = state.floorplanTableDragReducer;

        const {
          floorplanBookingsReducer: { floorplanBookings, floorplanBookingsByTable },
          floorplanFilterReducer: { selectedFloorplanTime },
          floorplanSectionsReducer: { floorplanSections },
          scheduleReducer: { selectedSchedule }
        } = state;

        const allLayouts = floorplanSections.reduce((layouts, sec) => {
          return [...layouts, ...sec.layouts];
        }, []);

        if (draggedBooking) {
          draggedBookingRef = draggedBooking;
        } else if (draggedBookingRef && (dragCompleteTableId || dragToTableBookingSlot)) {

          // drag and drop completed (as there is no draggedBooking), but we have the last reference to it in draggedBookingRef

          const clonedBooking = cloneDeep(draggedBookingRef); // dragged booking
          draggedBookingRef = null;
          store.dispatch(tableDragActions.resetBookingToSwap());

          const toTableId = dragToTableBookingSlot?.tableId || dragCompleteTableId;
          const fromTableId = dragFromTableBookingSlot?.tableId || dragFromTableId;
          const newTime = clonedBooking.time; // might be updated
          const dataDragToTable = FloorplanBookingDragService.getBookingsByTable(floorplanBookingsByTable, toTableId, dragToTableBookingSlot?.bookingIds);
          const dataDragFromTable = FloorplanBookingDragService.getBookingsByTable(floorplanBookingsByTable, fromTableId, dragFromTableBookingSlot?.bookingIds);

          if (clonedBooking.bookingType === BookingType.WaitList) {
            if (!Boolean(bookingConfirmDialog)) {

              const _isOverlap = FloorplanBookingDragService.checkIfWaitlistBookingOverlap({
                floorplanBookings,
                dragToTableId: toTableId,
                selectedFloorplanTime,
                dataDragToTable,
                booking: clonedBooking,
              });

              store.dispatch(tableDragActions.setIsShownBookingConfirmWL({
                dragToTableId: toTableId,
                draggedBooking: clonedBooking,
                isOverlap: _isOverlap
              }));
            }
            return;
          }

          let isOverlap = false;
          const tableList = TablesLookupService.getTablesFromLayoutObjects(allLayouts);
          const dragToTable = TablesLookupService.getTableByIdFromCache(toTableId);

          let isError = TableDragService.checkForErrorWhileDraggingTables(clonedBooking, dragToTable, tableList);
          let toTablesArray = !isError
            ? TableDragService.getConsecutiveTables(clonedBooking, dragToTable, tableList)
            : [dragToTable];
          let fromTableArray = dataDragFromTable ? [dataDragFromTable.table] : [];


          let tableJoinSwapError = false;
          let isBookingSwap = false;
          vm.hasSwappedTableChanged = false;


          if (bookingToSwap && !dataDragToTable?.table?.shared) {
            isBookingSwap = true;
            // is error is true if the dragged booking is swapping to a joined booking and there is no space available to swap
            isError = TableDragService.checkForErrorWhileDraggingTables(bookingToSwap, clonedBooking.tables[0], tableList);

            if (dataDragFromTable && dataDragToTable) {

              const firstBookingFromTable = dataDragFromTable.bookings[0];
              const dragToTableBookings = FloorplanBookingFilterService.getBookingsAtTime(dataDragToTable.bookings, selectedFloorplanTime);
              if (dragToTableBookings.length) {
                tableJoinSwapError = FloorplanBookingDragService.doBothBookingsHaveTableJoins(dragToTableBookings, firstBookingFromTable);
              }
            }

            const dropBackOnSelf = TableDragService.areSwappingBookingsOnSameTable(fromTableArray, toTablesArray);
            if (!dropBackOnSelf) {
              if (bookingToSwap.tables.length > 1) {
                toTablesArray = getAppropriateTable(bookingToSwap, clonedBooking, toTablesArray[0]);
              }
              if (clonedBooking.tables.length > 1) {
                fromTableArray = getAppropriateTable(clonedBooking, bookingToSwap, fromTableArray[0]);
              }

              /**
               * Now swapping the bookings won't change the booking time so, there is a chance that the dragged/dropped table already has a booking for that time.
               * In case of an overlap, show the overlap message in the swap modal.
               * e.g.
               * Swap Booking1(5:00PM - 5:30PM) from table T4 and Booking2(2:15PM - 3:30PM) from table T7.
               * If table T4 already has a Booking3(2:00PM - 3:30PM), then
               * show "This move will overlap a booking on a table, select move if you would like to proceed" message in the swap modal.
               */

              // Check overlap for dragged booking
              isOverlap = TableDragService.isOverlapBooking(floorplanBookingsByTable, toTablesArray, clonedBooking, bookingToSwap, true);

              // Check overlap for dropped booking
              if (!isOverlap) {
                isOverlap = TableDragService.isOverlapBooking(floorplanBookingsByTable, fromTableArray, bookingToSwap, clonedBooking, true);
              }
            }
          }
          else {
            /**
             * Check overlap, only if bookings are not swapped.
             * We are already checking the overlap for swap bookings in the above code.
             */
            const dropTime = dragFromTableBookingSlot?.startTime || selectedFloorplanTime;
            isOverlap = TableDragService.isOverlapOnProgressedBooking(floorplanBookingsByTable, toTablesArray, clonedBooking, dropTime);
          }

          // console.log('isError', isError)
          // console.log('isOverlap', isOverlap)
          // console.log('tableJoinSwapError', tableJoinSwapError)
          // console.log('vm.hasSwappedTableChanged', vm.hasSwappedTableChanged)

          try {
            showDragBookingConfirmDialog({
              dialogShowFn: $mdDialog.show,
              isFloorPlanV2: true,
              toTable: dragToTable || toTableId,
              toTablesArray,
              fromTable: fromTableId,
              fromTableArray,
              newTime: newTime,
              schedule: cloneDeep(selectedSchedule),
              dragBooking: clonedBooking,
              swapWithBooking: isBookingSwap ? ObjectCopyService.angularSafeCopy(bookingToSwap) : null,
              isError: isError,
              isOverlap: isOverlap,
              layouts: allLayouts, //vm.layouts,
              tableJoinSwapError,
              allTimes: [],
              hasSwappedTableChanged: vm.hasSwappedTableChanged,
              tableName: vm.tableName,
              cancelledCb: () => {
                clearDragTableReduxValues();
              },
              fulfilledCb: (res) => {
                clearDragTableReduxValues();
                if (res?.isSaved && isBookingSwap) {
                  store.dispatch(rootDisplayActions.showToastFullOptions({
                    msg: `Tables swapped.`,
                    isCleanStyle: true,
                  }))
                  setTimeout(() => {
                    store.dispatch(rootDisplayActions.clearToast())
                  }, 3000);
                }
              }
            });
          } catch (err) {
            console.warn('error with showDragBookingConfirmDialog', err);
          }
        }
      });

      listeners.push(unsubscribe);
    }
  }

  function clearDragTableReduxValues() {
    store.dispatch(tableDragActions.setDragToTableId(''));
    store.dispatch(tableDragActions.setDragFromTableId(''));
    store.dispatch(tableDragActions.setDragCompleteTableId(''));
    store.dispatch(tableDragActions.setDragToTableBookingSlot(null));
    store.dispatch(tableDragActions.setDragFromTableBookingSlot(null));
  }

  /**
   * Assigns most appropriate table based on pax requirement
   */
  function getAppropriateTable(toBooking, fromBooking, swappedWithTable) {

    const tablesArray = TableDragService.getAppropriateTable(toBooking, fromBooking);

    // Show a message to the user when the swapped table has changed.
    vm.hasSwappedTableChanged = swappedWithTable._id !== tablesArray[0]._id ? true : false;
    vm.tableName = `T${tablesArray[0].name}`;

    return tablesArray;
  }

  // function closeBookingCreator() {
  //   vm.showBookingCreator = false;
  // }

  async function bookingChange(updatedBookingIds) {

    if (updatedBookingIds.length === 1) {
      // if only 1 booking has been updated, don't re-render everything if it is just a quick edit
      const updatedBookingId = updatedBookingIds[0];
      // follow line for handle couchDB response, UI-1353, UI-1356
      store.dispatch(updateBookingIdsForCouchResponse(updatedBookingId));

      // must use vm.categorisedBookings because that cancelled bookings don't exist in vm.bookings
      // and standby bookings don't exist in vm.slotBookings
      const originalIndex = vm.categorisedBookings.findIndex(b => b._id === updatedBookingId);
      const originalBooking = ObjectCopyService.angularSafeCopy(vm.categorisedBookings[originalIndex]);

      let _newBooking;
      try {
        _newBooking = await BookingLookupService.getById(updatedBookingId, vm.filterDate);
      } catch (err) {
        console.warn(NS, `error retrieving booking by id "${updatedBookingId}".`);
      }

      if (_newBooking && originalBooking) {
        const containsOnlyQuickChanges = PouchSyncService.containsOnlyQuickChanges(originalBooking, _newBooking);
        if (containsOnlyQuickChanges) {
          // the reason we don't replace the whole list is that it will rerender the whole timeList.
          // it still can update one booking without that
          BookingListFilterService.replaceBookingInList(vm.slottedBookings, _newBooking);
          // Update runsheet in place: replace only the edited booking. Do NOT set runsheetBookings = slottedBookings,
          // because slottedBookings excludes wait list and most standby (filterSlottedBookings). That would make
          // standby/wait list bookings disappear until refresh. Runsheet is fed from filteredBookings (full list).
          BookingListFilterService.replaceBookingInList(vm.runsheetBookings, _newBooking);
          let {
            listWasModified, updatedRunsheetBookings
          } = BookingListFilterService.updateCancelledBookingsInList(vm.runsheetBookings, _newBooking, originalBooking);

          if (listWasModified) {
            vm.runsheetBookings = updatedRunsheetBookings;
          }
          // must use [...vm.categorisedBookings] or it won't rerender(only change status icon, but not move to right place)
          const updatedFilteredBookings = [...vm.categorisedBookings];
          updatedFilteredBookings[originalIndex] = ObjectCopyService.angularSafeCopy(_newBooking);
          setFilteredBookings(updatedFilteredBookings, true);
          /**
          * Also need to update floorplan views (but this is not optimised - entire floorplan will re-render)
          */
          updateFloorplanSingleBooking(_newBooking, updatedBookingId);
          TableUtilsService.addBookingRelatedDataToTables(_newBooking);
          handleShowRevertStatusButton();
          return;
        }
      }
    }
    getBookings();
  }

  function setFilteredBookings(value, onlyUpdateCategorised) {
    vm.categorisedBookings = value;

    if (onlyUpdateCategorised) {
      return;
    }

    vm.runsheetBookings = value;
  }

  function updateFloorplanSingleBooking(_newBooking, updatedBookingId) {
    let found = false;
    _newBooking.tables.forEach(table => {
      const data = vm.bookingsByTable[table._id];
      let targetBooking = data ? data.bookings.find(b => b._id === updatedBookingId) : null;
      if (targetBooking) {

        // not sure why this is immutable, so this is just a bit of a bandaid fix
        if (!Object.isExtensible(targetBooking)) {
          targetBooking = cloneDeep(targetBooking);
        }

        /**
         * The reason we only update these 2 properties (and deliberately mutate the object), instead of replacing the
         * whole object, is because the dragged booking has a reference to the same object and won't update with it unless
         * it is mutated. This is a bit ugly, but because the dragged booking is not rendered until it is interacted with
         * we can't update it with `PouchActions.handlePouchSyncedDoctype` in real time.
         */
        quickEditProps.forEach(propName => {
          targetBooking[propName] = _newBooking[propName];
        });
        targetBooking._rev = _newBooking._rev; // needs rev to avoid conflicts
        found = true;
      }
    });
    vm.bookingsByTable = clone(vm.bookingsByTable); // shallow clone so we get a floorplan re-render
  }

  function getNotes() {
    vm.hasNotes = false;

    NotesService.getNote(vm.filterDate).then(function (noteDoc) {
      if (noteDoc && noteDoc.note.length) {
        vm.hasNotes = true;
      }
    }).catch((err) => {
      vm.errorList.push(err);
    });
  }

  function checkForConflicts() {
    BookingsConflicts.checkForConflicts().then(function (conflicts) {
      vm.conflicts = conflicts;
    });
  }

  function editBookingPeople(evt, targetEvt, booking) {
    vm.peopleEditor = {};
    var y = targetEvt.pageY;
    if ((y + 200) > window.innerHeight) {
      y = y - 200;
    }
    vm.peopleEditor.position = {
      top: y,
      left: targetEvt.pageX
    };
    const bookingCopy = cloneDeep(booking);
    const service = vm.schedule?.services.find(({ _id }) => booking.serviceId === _id);
    const activePaymentDetails = PaymentService.setActivePayments(service.paymentDetails, service.additionalPaymentDetails,
      bookingCopy.people, bookingCopy.time);

    const originalBOIds = cloneDeep(activePaymentDetails?.menuOptions);
    const originalUOIds = cloneDeep(activePaymentDetails?.menuOptionsUpsell);

    vm.peopleEditor.originalActivePaymentDetails = { activePaymentDetails, originalBOIds, originalUOIds };

    vm.peopleEditor.booking = bookingCopy;

    const bookingTimesNew = BookingAvailabilityService.calulateBookingTimes(
      vm.schedule, vm.schedule.services.find(({ _id }) => booking.serviceId === _id), vm.layouts,
      booking.duration, booking.people, booking.tables, $scope.bookings.bookingsByTable,
      booking.preferredSectionId, null, true,
      null, true
    );


    vm.peopleEditor.bookingIntervals = bookingTimesNew;
    vm.peopleEditor.schedule = vm.schedule;
    vm.peopleEditor.bookings = vm.bookings;
    vm.peopleEditorOpen = true;
  }




  function editBookingStatus(evt, targetEvt, booking) {
    vm.statusEditor = {};
    var y = targetEvt.pageY;
    const { statusOptions } = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
    var statusHeight = (statusOptions.length * 48) + 16;
    statusHeight = (statusHeight > 400) ? 400 : statusHeight;
    if ((y + statusHeight) > window.innerHeight) {
      y = y - statusHeight;
    }
    var x = targetEvt.pageX;
    if (x + 210 > window.innerWidth) {
      x = targetEvt.pageX - 193;
    }
    vm.statusEditor.position = {
      top: y,
      left: x
    };
    vm.statusEditor.booking = cloneDeep(booking);
    vm.statusEditorOpen = true;
  }

  function closeBookingEdit() {
    vm.peopleEditorOpen = false;
    vm.statusEditorOpen = false;
  }


  function setFloorplanState(currentView) {
    const currentFloorplanState = store.getState().settingReducer.floorplanState;
    store.dispatch(settingActions.setBookingView(currentView));
    if (
      (
        currentFloorplanState === FloorPlanState.NOT_INITIALISED ||
        currentFloorplanState === FloorPlanState.DESTROYED
      ) && currentView !== MainViewType.FloorplanV2) {
      return;
    }

    if (
      (
        currentFloorplanState === FloorPlanState.INITIALISED ||
        currentFloorplanState === FloorPlanState.RESUMED
      ) && currentView !== MainViewType.FloorplanV2
    ) {
      store.dispatch(settingActions.setFloorplanState(FloorPlanState.STOPPED));
      // to stop the timers in Floorplan component
      PeriodicUpdateService.endTimer();
      PeriodicUpdateService.removeAllMainTrackFuncs();
    }

    if (currentFloorplanState === FloorPlanState.STOPPED && currentView === MainViewType.FloorplanV2) {
      store.dispatch(settingActions.setFloorplanState(FloorPlanState.RESUMED));
    }
  }

  function saveViewToLocalStorage(view) {
    const _view = view.view;
    const currentVenueId = vm.venue.id;
    const viewExpiryTime = DateUtilsService.getDateInFuture(1, 'days', true);

    const data = {
      venueId: currentVenueId,
      view: _view,
      expirationDate: viewExpiryTime,
    };

    LocalStorageService.set(
      NgLocalStorageKey.selectedDiaryView,
      JSON.stringify(data)
    );
  }

  function selectView(viewConfig) {

    if (
      !vm.mainViewConfig || // will be undefined if first load (eg, user from settings menu)
      (viewConfig.view !== MainViewType.FloorplanV2 && changeDatePending === true)
    ) {
      clearBookings();
      onChangeDate();
      changeDatePending = false;
    }

    setMainViewConfig(viewConfig.view);
    setFloorplanState(viewConfig.view);

    ViewActionsService.onViewChanged(viewConfig.view);
    saveViewToLocalStorage(viewConfig);
  }

  function clearBookings() {
    vm.bookings = null;
    setFilteredBookings(null);
    vm.slottedBookings = null;
    vm.bookingsByTable = null;
  }

  function onChangeDate() {

    NetworkConnectionService.checkCouchDbIsReachable();

    vm.previousFilterDate = vm.filterDate;

    setMainViewConfig(null, true, true);
    clearBookings();
    updateDay();
    getNotes();

    $rootScope.$broadcast('change-date', vm.filterDate);

    store.dispatch(scheduleActions.setSelectedDate(vm.filterDate));
  }

  function updateDay() {

    vm.state = vm.LOADING;
    gettingBookings = false;
    vm.peopleEditor = null;
    vm.bookingsByService = false;
    setTense();
    //check before today instead of 4am is because the date is set to 00:00:00 when selected
    vm.isBeforeToday = DateUtilsService.isBeforeToday(vm.filterDate, timeZoneId);
    getSchedule();
  }

  function getSchedule() {
    var previousService = (vm.serviceViewList) ? vm.serviceViewList[vm.currentService] : false;

    if (vm.filterDate) {
      var t0 = performance.now();
      ScheduleLookupService.getSchedule(vm.filterDate).then(function (schedule) {

        var t1 = performance.now();
        TelemetryService.track('getCompleteSchedule', [
          ['duration', t1 - t0]
        ]);
        vm.schedule = schedule;

        if (vm.schedule.services && vm.schedule.isOpen) {
          if (vm.schedule.services && vm.schedule.services.length) {
            vm.totalsServiceWidth = 160 / vm.schedule.services.length;

            const defSecLOs = SectionLookupService.getDefaultSectionLayouts(vm.schedule);
            const sectionIds = defSecLOs.sectionIds;
            vm.defaultSectionLayouts = defSecLOs.defaultSectionLayouts;

            ServicesLookupService.getServicesAndServiceGroups(vm.schedule)
              .pipe(first())
              .subscribe(serviceViewList => {
                vm.serviceViewList = ServicesLookupService.getTrueServicesOrder(sortBy(serviceViewList, 'order'));
                vm.currentService = ServicesLookupService.getPreviouslyFilteredService(previousService, vm.serviceViewList);
                vm.services = ServicesLookupService.getServicesFromServiceViewList(vm.currentService, vm.serviceViewList);

                getLayouts();
                checkOpen();
                defineAvailableSections(sectionIds);

                // change of date need to load the service times dropdown list again with latest data - only for floorplan view
                if (MainViewVisibilityService.isFloorplanV2Visible()) {
                  updateService();
                }

                $scope.$apply();
              });
          } else {
            closed();
          }
        } else {
          closed();
        }
      }).catch(function (err) {
        $log.error(err);
        vm.errorList.push(err);
        closed();
      });
    }
  }

  /**
   * Callback from serviceFilterComponent when service is selected
   */
  function onServiceFilterChanged(selectedIndex) {
    vm.currentService = selectedIndex;
  }

  /**
   * Callback from serviceFilterComponent when section is selected
   */
  function onSectionFilterChanged(selectedIndex) {
    vm.currentSection = selectedIndex;
    changeSection();
  }

  /**
   * Takes a list of services and ids and returns services that match the ids - not used - can remove?
   */
  function getServicesByIds(ids, servicesToSearch) {
    return ids.reduce((acc, id) => {
      const service = servicesToSearch.find(s => s._id === id);
      if (service) {
        acc.push(service);
      }
      return acc;
    }, []);
  }



  function closed() {
    vm.state = vm.ENTER;
    vm.schedule = false;
    vm.closed = true;
    vm.serviceViewList = [];
    setFilteredBookings([]);
    vm.slottedBookings = [];
    // vm.expanderWidth = 0;
  }

  function setIsClosedByRedux() {
    vm.closed = false;

    MainViewVisibilityService.setIsClosedByRedux(() => {
      const { scheduleReducer } = store.getState();
      return scheduleReducer;
    }, () => {
      vm.state = vm.LOADING;
    }, (isClosed) => {
      vm.closed = isClosed;
      vm.state = vm.ENTER;
    });
  }

  /**
   * Gets all layout used
   */
  function getLayouts() {

    if (vm.schedule) {
      var layoutsIds = [];
      for (var i = vm.schedule.services.length - 1; i >= 0; i--) {
        var service = vm.schedule.services[i];
        if (service) {
          for (var t = service.sectionLayouts.length - 1; t >= 0; t--) {
            layoutsIds.push(service.sectionLayouts[t].layoutId);

          }
        }
      }

      return LayoutsService.getLayouts(layoutsIds, vm.filterDate).then(function (layouts) {
        vm.layouts = layouts;
        var layoutLookUp = {};
        for (var l = 0; l < layouts.length; l++) {
          var layout = layouts[l];
          layoutLookUp[layout._id.substring(0, 20)] = layout;
        }
        vm.layoutLookUp = layoutLookUp;
        getBookings();
      });
    }
  }

  function defineAvailableSections(sectionIds) {
    SectionLookupService.getSectionsLookUp().then(function (lookUps) {
      sectionsLookUp = lookUps;
      return lookUps;
    }).then(function () {
      return SectionGroupsService.getSectionGroups();
    }).then(function (sectionGroups) {
      vm.sectionOptions = SectionGroupsService.getSectionOptions(sectionsLookUp, sectionGroups, sectionIds);
    });
  }

  function serviceChange(value, oldValue) {
    if (Number(value) !== Number(oldValue) && oldValue !== null && oldValue !== undefined) {
      updateService();
    }
  }

  function setIsBookingCardListShown() {
    if (!MainViewVisibilityService.isFloorplanV2Visible() && vm.useBookingCardList) {
      vm.isBookingCardListShown = true;
      return;
    }
    if (MainViewVisibilityService.isFloorplanV2Visible()) {
      vm.isBookingCardListShown = true;
      return;
    }
    vm.isBookingCardListShown = false;
  }

  function checkOpen() {
    if (vm.schedule) {
      var timeNow = DateUtilsService.getVenueTime(timeZoneId);

      var openTime = vm.schedule.services[0].startTime;
      var closeTime = vm.schedule.services[vm.schedule.services.length - 1].endTime;
      if (DateUtilsService.isInBetweenDates(timeNow, openTime, closeTime)) {
        var open = false;
        for (var i = vm.schedule.services.length - 1; i >= 0; i--) {
          var service = vm.schedule.services[i];
          var startTime = service.startTime;
          var endTime = service.endTime;
          if (DateUtilsService.isInBetweenDates(timeNow, startTime, endTime)) {
            open = true;
            break;
          }
        }
        vm.isOpen = open;
      } else {
        vm.isOpen = false;
      }

      if (!vm.skipCheckOpenPoll) {
        // check if the resturant is open once a min
        $timeout(checkOpen, 60000);
      }
    }
  }

  function updateService() {
    if (vm.schedule) {
      if (!vm.bookingsByService) {
        // there are no bookings get them
        getBookings();
      } else {
        const selectedServiceView = vm.serviceViewList[vm.currentService];
        if (selectedServiceView) {
          if (!selectedServiceView.services && !selectedServiceView.service) {
            // when selected all in service dropdown, we need to set the selectedServiceView to null
            store.dispatch(serviceActions.setSelectedServiceView(null));
            store.dispatch(filterBookingActions.setFilterServiceView(null))
          } else {
            store.dispatch(serviceActions.setSelectedServiceView(selectedServiceView));
            store.dispatch(filterBookingActions.setFilterServiceView(selectedServiceView))
          }
        }

        vm.services = ServicesLookupService.getServicesFromServiceViewList(vm.currentService, vm.serviceViewList);
        const res = BookingLookupService.filterBookings(vm.currentService, vm.schedule, vm.bookings, vm.bookingsByService,
          vm.serviceViewList, vm.selectedSectionIds, false);
        setFilteredBookings(res.filteredBookings);
        vm.slottedBookings = res.slottedBookings;
      }
    }
  }

  // used when clicking 'Now'
  function selectService(evt, serviceIndex) {
    vm.currentService = serviceIndex + 1;
  }

  function selectServiceById(evt, serviceId) {
    for (var i = vm.serviceViewList.length - 1; i >= 0; i--) {
      if (vm.serviceViewList[i].service && vm.serviceViewList[i].service._id === serviceId) {
        vm.currentService = i;
        break;
      }
    }
  }

  // this function gets the data from the FP header date change and updates the timeline date
  function handleDateChangedViaFloorplan(date) {

    if (vm.filterDate.getTime() === date.getTime()) {
      // No change. Do nothing.
      return;
    }

    vm.filterDate = date;

    // needed a timeout so the vm.filterDate watchers can do their updates
    setTimeout(setIsClosedByRedux, 0);
  }

  function changeSection() {
    vm.selectedSectionIds = false;
    if (vm.currentSection !== 0) {
      vm.selectedSectionIds = vm.sectionOptions[vm.currentSection].sectionIds;
    }
    const section = vm.sectionOptions[vm.currentSection]
    // when section is not selected the Overview
    if (!!section?.sectionIds) {
      store.dispatch(sectionActions.setSection(section));
    } else {
      store.dispatch(sectionActions.setSection(null));
    }
    store.dispatch(floorplanV2SectionsActions.setSelectedSectionIds(vm.selectedSectionIds || []));
    const res = BookingLookupService.filterBookings(vm.currentService, vm.schedule, vm.bookings, vm.bookingsByService,
      vm.serviceViewList, vm.selectedSectionIds, false);
    setFilteredBookings(res.filteredBookings);
    vm.slottedBookings = res.slottedBookings;
  }

  //function filterBookings move to booking-lookup-service------------>


  // function getBookingsByService move to booking-lookup-service(submodule)-------------->



  /**
   * Appends function tracker bookings to the provided service if exists
   * function appendFunctionTrackerBookings move to booking-lookup-service(submodule)
   */



  function getBookings(repeat) {

    if (!repeat) {
      bookingQue++;
    }
    if (vm.schedule && vm.layouts && !gettingBookings) {
      vm.state = vm.LOADING;
      gettingBookings = true;

      /**
       * @todo: it looks like the purpose of repeat + bookingQue is to do another getBySchedule + parseBookings
       * call even though there is one already running. Ideally, this should just cancel the previous calls so they
       * don't try and render twice. May need to convert bookingsService.getBySchedule to RxJS Observable (fromPromise)
       * so it is cancellable.
       */
      BookingLookupService.getBySchedule(vm.schedule).then(function (results) {
        var schedule = results.schedule;
        if (schedule._id === vm.schedule._id) {
          var bookings = results.bookings;
          vm.bookings = $filter('orderBy')(bookings, 'time');
          parseBookings().then(function () {
            // vm.slottedBookings.forEach(sb => {
            //   console.log(NS, Object.isExtensible(sb), 'vm.slottedBookings', sb);
            // })
            return BookingAvailabilityService.getBookingsByTable(vm.slottedBookings);
          }).then(function (bookingsByTable) {
            // for (var a in bookingsByTable) {
            //   bookingsByTable[a].bookings.forEach(b => {
            //     console.log(NS, 'getBookings / bookingsByTable', Object.isExtensible(b), bookingsByTable[a], b._id)
            //   })
            // }
            vm.bookingsByTable = bookingsByTable;
          }).then(function () {
            vm.closed = false;
          }).catch(function (err) {
            $log.error(err);
            vm.errorList.push(err);
          });
        } else {
          vm.bookingsByService = false;
        }

        bookingQue--;
        gettingBookings = false;
        vm.state = vm.ENTER;
        vm.showFinishAllButton = (vm.isPast || vm.isToday);
        handleShowRevertStatusButton();
        recheckBooking();
      }).catch(function (err) {
        gettingBookings = false;
        vm.state = vm.FAILED_TO_LOAD_BOOKING;
        vm.errorList.push(err);
        console.warn('BookingLookupService.getBySchedule error', err);
      });
    }
  }

  function getErrorDetails() {
    return vm.errorList;
  }

  function addPeople() {
    // -------change to forEach-------------------
    vm.bookings.forEach((booking) => {
      var orgBooking = cloneDeep(booking);
      booking.people++;
      BookingUpdateService.updateFromAnywhere(booking, orgBooking);
    });

  }

  function minusPeople() {
    // -------change to forEach-------------------
    vm.bookings.forEach((booking) => {
      var orgBooking = cloneDeep(booking);
      booking.people--;
      BookingUpdateService.updateFromAnywhere(booking, orgBooking);
    });
  }

  function recheckBooking() {
    if (bookingQue > 0) {
      // recheck bookings
      getBookings(true);
    } else {
      requestConflictCheck();
    }
  }

  function requestConflictCheck() {
    if (checkForAffectedBookingInterval) {
      $timeout.cancel(checkForAffectedBookingInterval);
    }
    /**
     * NBI-592 reduced the timeout from 1000 to 100 because the delay was noticable to the user,
     * when switching days on the floorplan view.
     * Not sure why the delay was originally so high, but my guess is because detecting booking conflicts was
     * not so noticable, so the delay wasn't important.
     */
    checkForAffectedBookingInterval = $timeout(checkForAffectedBooking, 100);
  }

  function checkForAffectedBooking() {
    if (checkForAffectedBookingInterval) {
      $timeout.cancel(checkForAffectedBookingInterval);
    }
    BookingsAffectedService.checkDay(vm.filterDate, vm.schedule, vm.bookings).then(function (affectedBookings) {
      vm.affectedBookings = affectedBookings;
    });
    checkForConflicts();
  }

  function parseBookings() {
    return $q(function (resolve, reject) {

      const timeNow = DateUtilsService.getVenueTime(timeZoneId);
      const { statusOptions } = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
      // checks first that `vm.currentService` is an index of `vm.serviceViewList`
      if (!vm.serviceViewList[vm.currentService]) {
        reject();
        return;
      }

      vm.services = ServicesLookupService.getServicesFromServiceViewList(vm.currentService, vm.serviceViewList);

      const haveAtleastOneFunctionTrackerBooking = vm.bookings?.some(booking => booking.functionTracker === true) || false;

      const bookingsByService = BookingLookupService.setBookingsByServiceObject(vm.serviceViewList, haveAtleastOneFunctionTrackerBooking);

      // Extracts the key from the last item in the bookingsByService.
      const lastItemKey = Object.keys(bookingsByService).pop();

      // var tables = {};

      vm.bookings.forEach((booking) => {
        booking.bookingMin = DateUtilsService.minsBetweenDates(vm.filterDate, booking.time);
        const bookingDate = booking.time;

        try {
          // this below logic to check for all current and future bookings and get the updated status information and replace it in the booking - https://nowbookit.atlassian.net/browse/NBI-6968
          const isBookingDateExpired = DateUtilsService.checkIfBookingInPastDay(bookingDate, timeNow);
          if (!isBookingDateExpired && booking.status?.editable) {
            const selectedStatus = statusOptions.find((status) => status._id === booking.status._id);
            if (booking.status && selectedStatus) {
              booking.status.name = selectedStatus.name;
              booking.status.code = selectedStatus.code;
              booking.status.statusColor = selectedStatus.statusColor;
            }
          }
        } catch (err) {
          console.log(NS, "problem trying to update statuses of current and future bookings", booking, err);
        }

        const serviceIndex = BookingsUtilsService.getServiceFromBooking(booking, vm.serviceViewList);

        if (serviceIndex !== -1) {
          // test if they are in the current layout

          booking.sharedOverCapacity = false;
          // loop over tables to test share table capacity

          if (booking.tables && booking.tables.length) {
            // work out if the booking is using a predefined table join
            if (booking.tables.length > 1) {
              // see if the booking matches a table join
              TableJoinService.setTableJoinForBooking(booking, vm.layouts);
            } else {
              delete booking.tableJoin;
            }

            /** -------change to forEach-------------------
             * Move this snippet into table-utils-service into a new function addBookingRelatedDataToTables
             */
          }

          let bookingByService = null;

          /** Adds the function tracker bookings to function tracker service */
          if (booking.functionTracker) {
            bookingByService = bookingsByService[lastItemKey];
          } else {
            bookingByService = bookingsByService[serviceIndex];
          }

          bookingByService.bookings.push(booking);

          // wait list bookings shouldn't count towards totals
          if (!StatusService.isBookingCancelled(booking) && !StatusService.isBookingWaitList(booking)) {
            bookingByService.bookingsCount++;

            if (!EventsService.isPrivateFunEvent(bookingByService.service)) {
              bookingByService.covers += booking.people;
            }
          }
        } // end if serviceIndex
      });

      const res = BookingLookupService.filterBookings(vm.currentService, vm.schedule, vm.bookings, bookingsByService,
        vm.serviceViewList, vm.selectedSectionIds, true);

      setFilteredBookings(res.filteredBookings);
      vm.slottedBookings = res.slottedBookings;
      //following snippet is move to function filterBookings in booking-lookup-service

      // Increase the width of the booking list even when, atleast one function tracker event booking exist
      vm.bookingsByService = ((vm.schedule.services && vm.schedule.services.length > 1) || haveAtleastOneFunctionTrackerBooking) ? bookingsByService : false;

      resolve();
    });
  }

  // function isTableIntoSelectedSections move to booking-lookup-service

  function walkin(evt, targetEvt) {
    var date = cloneDeep(vm.filterDate);
    var now = DateUtilsService.getVenueTime(timeZoneId);
    date.setHours(now.getHours());
    date.setMinutes(now.getMinutes());
    date.setSeconds(0);
    date.setMilliseconds(0);
    newBooking(evt, targetEvt, date, null, BookingMethods.walkin);
  }

  function listenForMegaBookingBotButton() {
    vm.showMegaBookingBotButton = true;
  }

  function megaBookingBotOpen(evt) {
    SpamProtectionService.setIsTurnOff(true);
    vm.showMegaBookingBot = true;
  }
  function megaBookingBotClose(evt) {
    SpamProtectionService.setIsTurnOff(false);
    vm.showMegaBookingBot = false;
  }

  /**
   * open a new booking window
   */
  function newBooking(evt, targetEvt, date, table, bookingMethod, bookingToMove, customer) {
    if (!date) {
      date = vm.filterDate;
    }
    bookingMethod = (bookingMethod) ? bookingMethod : BookingMethods.phone;
    const floorplanSettings = store.getState().floorplanSettingsReducer.floorplanSettings;
    const bookingView = store.getState().settingReducer.bookingView;
    let closestService = null;
    if (bookingView === MainViewType.FloorplanV2 && floorplanSettings.enableBookingCreatorOnFloorplan) {
      // choose a service close to the selected time
      const services = store.getState().serviceReducer.currentServiceViews?.map((info) => info.service).filter((service) => !!service) || [];
      const selectedFloorplanTime = store.getState().floorplanFilterReducer?.selectedFloorplanTime;
      // getting the closest service based on the header time
      if (selectedFloorplanTime && services.length > 0) {
        closestService = services.find((service) => {
          return DateUtilsService.isInBetweenDates(selectedFloorplanTime, service.startTime, service.endTime);
        });
      }
    }
    AppEventService.emit('newBooking', {
      date: date,
      table: table,
      bookingMethod: bookingMethod,
      bookingToMove: bookingToMove,
      customer: customer,
      selectedService: closestService
    }, evt);
  }

  function showConflicts(evt, targetEvt, targetTableId = null) {
    var conflicts;
    if (targetTableId) {
      const selectedFPTime = store.getState().floorplanFilterReducer.selectedFloorplanTime;
      const conflictedBookings = store.getState().floorplanTableInteractionsReducer.conflictedBookings;

      const currentDate = DateUtilsService.getVenueTime(timeZoneId);
      let conflictStartTime = selectedFPTime || currentDate;
      // this logic is mainly for FP slot view having conflicts - if conflicts exists we need to show the conflict matching the pressed slot start time
      // otherwise it was showing the conflicts based on the selected time
      if (conflictedBookings?.length > 1) {
        conflictStartTime = sortBy(conflictedBookings.slice(), 'time')[0].time; // sorting to get the earliest time for the conflict
      }
      conflicts = FloorplanConflictsService.getConflictsAtTime(targetTableId, vm.conflicts, conflictStartTime);
    } else {
      conflicts = vm.conflicts;
    }

    evt?.currentTarget?.blur();
    store.dispatch(bookingActions.setOverlapConflicts(conflicts));
    store.dispatch(rootDisplayActions.setShowBookingConflictsModal(true));
  }

  function unallocateAllBookings(evt) {
    var confirm = $mdDialog.confirm()
      .parent(angular.element(document.body))
      .title('Are you sure?')
      .content('All upcoming bookings on your current view will be have their tables removed, and the bookings will be added to the wait list.')
      .ariaLabel('Unallocate All bookins')
      .ok('Yes')
      .cancel('No')
      .targetEvent(evt);
    $mdDialog.show(confirm).then(function () {
      BookingService.unAllocateBookingsTables(cloneDeep(vm.categorisedBookings));
      BookingService.unAllocateBookingsTables(cloneDeep(vm.slottedBookings));
    });
  }

  function openGlobalSearch(evt) {
    AppEventService.emit('openGlobalSearch', vm.filterDate, evt);
  }

  function openNotes(evt) {
    AppEventService.emit('openNotes', {
      date: vm.filterDate
    }, evt);
  }

  function setExpanderWidth(dynamicWidth, staticWidth) {
    const width = dynamicWidth + staticWidth;
    vm.expanderWidth = width > MIN_EXPANDER_W ? width : MIN_EXPANDER_W;
  }

  /**
   * PRIVATE METHODS BELOW HERE
   */

  /**
   * the 'isPrivateFunEvent' function move to src/app/services/events/events.service.ts
   */

  /**
   * Checks if a booking's tables are an exact match with an existing table join and,
   * if so, populates the 'tableJoin' property on the booking.
   * function getLayoutByTable move to src/app/services/tableJoin/tableJoin.service.ts
   */

  //function setTableJoinForBooking move to src/app/services/tableJoin/tableJoin.service.ts


  /**
   * Populates and returns a plain object literal with index number for prop names
   * function setBookingsByServiceObject move to booking-lookup-service(submodule)
   */


  /** Populates booking service info */
  // 'makeBookingService' function move to booking-generator-service.ts


  /**
   * Checks to see if any of the past booking have ended. If so, removes people from the total
   * and nulls out the 'bookingsAtTable' prop.
   * @param tableObj - {
            lastBooking: boolean,
            totalPeopleAtTable: number,
            bookingsAtTime: array of bookings
            table: table object
            bookingsAtTable: array of bookings
          }
   */
  // function removePastBookingsFromTable move to table-utils-service.ts(submodule)


  // function isBookingCancelled move to src/app/services/status/Status.service.ts

  /**
   * Filters out waitlist and standby bookings (unless they are in StandbyPending), so just returns bookings
   * that should be shown on the timeline and floorplan. Runsheet should not be affected by this filter.
   * function filterSlottedBookings move to booking-lookup-service(submodule)
   */


  function finishAllBookings(evt) {
    var confirm = $mdDialog.confirm()
      .parent(angular.element(document.body))
      .title('Are you sure?')
      .content('All bookings on your current view will be changed to Finished status.')
      .ariaLabel('Finish All Bookings')
      .ok('Yes')
      .cancel('No')
      .targetEvent(evt);

    $mdDialog.show(confirm).then(function () {
      BookingService.finishAllBookings(vm.filterDate);
    });
  }

  function reverseFinishAllBookings(evt) {

    var confirm = $mdDialog.confirm()
      .parent(angular.element(document.body))
      .title('Are you sure?')
      .content('Revert bookings status change by "Finish All" back to original status.')
      .ariaLabel('Revert status of all bookings')
      .ok('Yes')
      .cancel('No')
      .targetEvent(evt);

    $mdDialog.show(confirm).then(function () {
      BookingService.reverseFinishAllBookings(vm.filterDate);
    });
  }
  function handleShowRevertStatusButton() {
    vm.showRevertStatusButton = vm.bookings?.some(b => b.status.name === BookingStatusNames.FinishAll
      || (b.status.name === BookingStatusNames.Finished && b.statusForRevertFinishAll)) && (vm.isPast || vm.isToday);
  }


  function handleFloorplanConflictedTableClick(tableId) {
    showConflicts(null, null, tableId);
  }
}
